// url

export default 'https://vintage-tech-be.herokuapp.com'
// export default 'http://localhost:1337'

// local fix
// setup free claudinary
